import { render, staticRenderFns } from "./FinaliseDialog.vue?vue&type=template&id=2760a49d&"
import script from "./FinaliseDialog.vue?vue&type=script&lang=js&"
export * from "./FinaliseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports